import { setLayoutsAction as setLayoutsOperation } from 'editor/src/store/editorModules/layouts/slice';

export default setLayoutsOperation;
